import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot } from '@angular/router';
import { AccessRoleTypes } from '@next/core-lib';
import { AuthGuard } from '@next/core-lib/authorization';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ArablePartnerHubRoleGuard implements CanActivate {
  constructor(private readonly authGuard: AuthGuard) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    return this.authGuard.canActivate(route, state, [
      AccessRoleTypes.Intermediary,
      AccessRoleTypes.GlobalAdministrator,
    ]);
  }
}
